/* @flow */
import * as React from 'react';
import styled from 'styled-components';

import { Box, Flex, Footer, Space, Table, Text } from '@sonyged/proc-ui';
import { ProcModal } from '@sonyged/ext-proc';
import css from '@styled-system/css';

import { AGE_BASE, AGE_RANGE } from '../../../../sushi/rules/thirdYear';
import { AgeGroup, Gender } from '../../../../sushi/constants';
import { ContentScroll } from '../../../../common/components/ContentScroll';
import type { Customer } from '../../../../sushi/rules/types';
import { CustomerIcon } from '../../../../sushi/components/CustomerIcon';
import { Tab } from '../../../../common/components/Tab/Tab';
import { Tabs } from '../../../../common/components/Tab/Tabs';
import IconImg from '../../../../assets/images/pages/sushi/icon_sushi_field_man.svg';
import sushiDishIcon1 from '../../../../assets/images/pages/sushi/sushi/sushi_ﬁ_g3-dish-icon01@3x.png';
import sushiDishIcon2 from '../../../../assets/images/pages/sushi/sushi/sushi_ﬁ_g3-dish-icon02@3x.png';
import sushiDishIcon3 from '../../../../assets/images/pages/sushi/sushi/sushi_ﬁ_g3-dish-icon03@3x.png';
import sushiDishIcon4 from '../../../../assets/images/pages/sushi/sushi/sushi_ﬁ_g3-dish-icon04@3x.png';
import sushiIcon01 from '../../../../assets/images/pages/sushi/sushi/sushi_ﬁ_icon-whi01@3x.png';
import sushiIcon02 from '../../../../assets/images/pages/sushi/sushi/sushi_ﬁ_icon-whi02@3x.png';
import sushiIcon03 from '../../../../assets/images/pages/sushi/sushi/sushi_ﬁ_icon-whi03@3x.png';
import sushiIcon04 from '../../../../assets/images/pages/sushi/sushi/sushi_ﬁ_icon-whi04@3x.png';
import sushiIcon05 from '../../../../assets/images/pages/sushi/sushi/sushi_ﬁ_icon-whi05@3x.png';
import sushiIcon06 from '../../../../assets/images/pages/sushi/sushi/sushi_ﬁ_icon-whi06@3x.png';
import sushiIcon07 from '../../../../assets/images/pages/sushi/sushi/sushi_ﬁ_icon-whi07@3x.png';
import sushiIcon08 from '../../../../assets/images/pages/sushi/sushi/sushi_ﬁ_icon-whi08@3x.png';
import sushiIcon09 from '../../../../assets/images/pages/sushi/sushi/sushi_ﬁ_icon-whi09@3x.png';
import sushiIcon10 from '../../../../assets/images/pages/sushi/sushi/sushi_ﬁ_icon-whi10@3x.png';
import sushiIcon11 from '../../../../assets/images/pages/sushi/sushi/sushi_ﬁ_icon-whi11@3x.png';
import sushiIcon12 from '../../../../assets/images/pages/sushi/sushi/sushi_ﬁ_icon-whi12@3x.png';

const icon = {
  '1-1': sushiIcon01,
  '1-2': sushiIcon02,
  '1-3': sushiIcon03,
  '2-1': sushiIcon04,
  '2-2': sushiIcon05,
  '2-3': sushiIcon06,
  '3-1': sushiIcon07,
  '3-2': sushiIcon08,
  '3-3': sushiIcon09,
  '4-1': sushiIcon10,
  '4-2': sushiIcon11,
  '4-3': sushiIcon12,
};

const sushiDishIcon = {
  '1': sushiDishIcon1,
  '2': sushiDishIcon2,
  '3': sushiDishIcon3,
  '4': sushiDishIcon4,
};

type Props = {
  customer: Customer,
  onClose: Function,
};

export function SushiCustomerStatModal(props: Props) {
  const { customer, onClose } = props;

  let sushiInfo = React.useMemo(() => {
    return sushiData[customer.gender][customer.ageGroup].map(sushiNames => [
      customer,
      sushiNames.map(name => icon[name]),
    ]);
  }, [customer]);
  let sushiKindInfo = React.useMemo(() => {
    return sushiData[customer.gender][customer.ageGroup].map(sushiNames => [
      customer,
      sushiNames.map(name => sushiDishIcon[name.split('-')[0]]),
    ]);
  }, [customer]);

  return (
    <ProcModal isOpened rootNodeId="proc-sushi-fields-root-page">
      <div key="modal" className={'proc-modal proc-modal--hint'}>
        <div className="proc-modal-container">
          <Space mb={[8, 8, 6]}>
            <TitleContainer>
              <AvatarContainer>
                <UserAvatar customer={customer} />
                <Text color="white" fontSize={[13, 13, 16]} lineHeight="title">
                  {customer.age}才
                </Text>
              </AvatarContainer>
              <Title>年れいが近い人のきろく</Title>
            </TitleContainer>
          </Space>
          <Contents>
            <ModalTabs>
              <Tab title="おすしのネタ">
                <ContentScroll flex={1} minHeight={0} gradientHeight={12}>
                  <EatenInfo data={sushiInfo} />
                </ContentScroll>
              </Tab>
              <Tab title="しゅるい">
                <ContentScroll flex={1} minHeight={0} gradientHeight={12}>
                  <Flex flexWrap="wrap">
                    <Space mb={[10, 10, 15]}>
                      <Flex alignItems="flex-end">
                        <SushiIcon src={sushiDishIcon[1]} alt="sushi" />
                        <SushiName>にぎり①</SushiName>
                      </Flex>
                      <Flex alignItems="flex-end">
                        <SushiIcon src={sushiDishIcon[2]} alt="sushi" />
                        <SushiName>にぎり②</SushiName>
                      </Flex>
                      <Flex alignItems="flex-end">
                        <SushiIcon src={sushiDishIcon[3]} alt="sushi" />
                        <SushiName>ぐんかん</SushiName>
                      </Flex>
                      <Flex alignItems="flex-end">
                        <SushiIcon src={sushiDishIcon[4]} alt="sushi" />
                        <SushiName>まき物</SushiName>
                      </Flex>
                    </Space>
                  </Flex>
                  <EatenInfo data={sushiKindInfo} />
                </ContentScroll>
              </Tab>
            </ModalTabs>
          </Contents>
        </div>
        <Footer shadow={false} variant="raised">
          <Footer.MainButton onClick={onClose} className="modal-close-se">
            とじる
          </Footer.MainButton>
        </Footer>
      </div>
    </ProcModal>
  );
}

const Contents = styled(Box)(
  css({
    position: 'relative',
    flex: 1,
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
    px: 16,
  })
);

const ModalTabs = styled(Tabs)(
  css({
    flex: 1,
    minHeight: 0,
    '.proc-tabbar': {
      mb: [8, 8, 18], // "real" margin are 20/30 because there is also padding of 12 for gradient
    },
  })
);

const UserAvatar = styled(CustomerIcon)(
  css({
    width: [35, 35, 48],
    height: [35, 35, 48],
    bg: '#fff',
    borderRadius: '50%',
    mr: '6px',
  })
);

const SushiIcon = styled('img')(
  css({
    size: ['24px', '24px', '32px'],
  })
);

const SushiName = styled('div')(
  css({
    color: '#fff',
    fontSize: ['13px', '13px', '20px'],
    marginLeft: [2, 2, 3],
    marginRight: [8, 8, 12],
  })
);

const sushiData = {
  [Gender.MALE]: {
    [AgeGroup.CHILD]: [
      ['1-1', '2-1', '2-2', '3-1', '3-3'],
      ['1-2', '3-3', '2-3', '3-2', '3-3'],
      ['1-3', '3-1', '3-1', '3-3', '3-3'],
      ['1-3', '4-1', '2-2', '3-3', '3-3'],
      ['1-1', '2-1', '3-2', '3-1', '3-3'],
      ['3-2', '4-2', '1-3', '1-2', '3-3'],
      ['1-3', '3-2', '2-1', '3-3', '3-3'],
      ['1-2', '3-3', '3-1', '3-2', '3-3'],
      ['1-2', '3-1', '4-3', '3-2', '3-3'],
      ['3-1', '3-3', '3-2', '1-1', '3-3'],
    ],
    [AgeGroup.ADULT]: [
      ['1-1', '2-1', '2-2', '3-1', '1-3'],
      ['3-2', '1-1', '4-1', '1-2', '1-3'],
      ['1-2', '1-1', '1-1', '3-2', '1-3'],
      ['1-3', '4-2', '1-2', '3-3', '1-3'],
      ['1-3', '1-2', '1-1', '3-3', '1-3'],
      ['3-1', '1-2', '2-3', '1-1', '1-3'],
      ['1-2', '4-3', '2-3', '3-2', '1-3'],
      ['1-3', '2-2', '3-2', '3-3', '1-3'],
      ['1-1', '1-3', '1-3', '3-1', '1-3'],
      ['1-1', '1-3', '2-1', '3-1', '1-3'],
    ],
    [AgeGroup.MIDDLE_AGE]: [
      ['1-1', '4-2', '1-3', '3-1', '4-3'],
      ['1-2', '3-1', '4-3', '3-2', '4-3'],
      ['1-1', '1-2', '1-1', '3-1', '4-3'],
      ['1-3', '3-2', '4-1', '3-3', '4-3'],
      ['3-2', '1-3', '3-2', '1-2', '4-3'],
      ['1-1', '3-1', '1-2', '3-1', '4-3'],
      ['1-2', '1-1', '3-1', '3-2', '4-3'],
      ['1-3', '3-3', '4-2', '3-3', '4-3'],
      ['3-1', '4-1', '1-2', '1-1', '4-3'],
      ['1-3', '3-2', '4-2', '3-3', '4-3'],
    ],
  },
  [Gender.FEMALE]: {
    [AgeGroup.CHILD]: [
      ['2-1', '2-1', '2-2', '4-1', '2-1'],
      ['4-1', '1-1', '3-2', '2-1', '2-1'],
      ['4-1', '3-2', '3-1', '2-1', '2-1'],
      ['4-2', '2-1', '1-1', '2-2', '2-1'],
      ['4-3', '2-3', '2-1', '2-3', '2-1'],
      ['2-2', '1-3', '3-2', '4-2', '2-1'],
      ['4-3', '2-2', '2-1', '2-3', '2-1'],
      ['4-2', '3-3', '4-3', '2-2', '2-1'],
      ['4-3', '2-2', '2-3', '2-3', '2-1'],
      ['4-1', '2-3', '3-3', '2-1', '2-1'],
    ],
    [AgeGroup.ADULT]: [
      ['4-2', '2-2', '1-1', '2-2', '1-1'],
      ['2-1', '1-1', '4-2', '4-1', '1-1'],
      ['2-2', '4-1', '2-1', '4-2', '1-1'],
      ['4-2', '2-1', '1-2', '2-2', '1-1'],
      ['4-3', '2-3', '4-1', '2-3', '1-1'],
      ['4-1', '1-2', '4-3', '2-1', '1-1'],
      ['4-3', '4-2', '1-3', '2-3', '1-1'],
      ['4-2', '2-1', '4-3', '2-2', '1-1'],
      ['4-1', '4-1', '2-3', '2-1', '1-1'],
      ['4-3', '2-3', '1-3', '2-3', '1-1'],
    ],
    [AgeGroup.MIDDLE_AGE]: [
      ['4-1', '1-1', '4-2', '2-1', '4-2'],
      ['4-1', '4-1', '3-1', '2-1', '4-2'],
      ['2-1', '4-3', '3-2', '4-1', '4-2'],
      ['4-2', '3-1', '4-2', '2-2', '4-2'],
      ['4-3', '4-1', '2-2', '2-3', '4-2'],
      ['4-3', '4-2', '1-3', '2-3', '4-2'],
      ['4-2', '1-2', '4-3', '2-2', '4-2'],
      ['4-3', '3-2', '4-1', '2-3', '4-2'],
      ['2-2', '4-3', '3-3', '4-2', '4-2'],
      ['4-1', '4-1', '3-1', '2-1', '4-2'],
    ],
  },
};

type EatenInfoProps = {
  data: Array<[Customer, string[]]>,
};
const EatenInfo = function(props: EatenInfoProps) {
  let { data, ...rest } = props;
  return (
    <EatenTable {...rest}>
      <thead>
        <tr>
          <th />
          <th>食べたじゅんばん(1さら目→5さら目)</th>
        </tr>
      </thead>
      <tbody>
        {data.map(([customer, icons], i) => (
          <tr key={i}>
            <td>
              <Flex alignItems="center">
                <CustomerAvatar src={IconImg} />
                <CustomerAge>
                  {AGE_BASE[customer.ageGroup] +
                    Math.floor((Math.sin(i) - Math.floor(Math.sin(i))) * AGE_RANGE[customer.ageGroup])}
                  才
                </CustomerAge>
              </Flex>
            </td>
            <td>
              <IconList>
                {icons.map((src, j) => (
                  <IconItem key={j} src={src} />
                ))}
              </IconList>
            </td>
          </tr>
        ))}
      </tbody>
    </EatenTable>
  );
};

const EatenTable = styled(Table).attrs({ borderRadius: [8, 8, 15] })(
  css({
    width: '100%',
    fontSize: [13, 13, 20],
    color: 'gray100',

    // iPhone SE
    '@media screen and (max-width: 360px)': {
      fontSize: 12,
    },

    tbody: {
      bg: 'white',
    },

    'th, td': {
      px: [12, 12, 16],
      fontWeight: 'normal',
      lineHeight: 'title',
    },

    th: {
      textAlign: 'left',
      py: [4, 4, 6],
    },

    td: {
      color: 'secondary100',
    },
  })
);

const CustomerAvatar = styled('img')(
  css({
    size: [24, 24, 32],
  })
);

const CustomerAge = styled('span')({
  // iPhone SE
  '@media screen and (max-width: 360px)': {
    display: 'none',
  },
});

const IconList = styled(Flex)(
  css({
    py: [5, 5, 10],
    '> * + *': {
      ml: [10, 10, 24],
    },
  })
);

const IconItem = styled('img')(
  css({
    size: [36, 36, 48],
  })
);

const TitleContainer = styled.div(
  css({
    display: 'flex',
    justifyContent: 'center',
    mx: [16, 0, 0],
    fontSize: ['mobile.large', 'smallPC.large', 36],
    color: 'white',
    lineHeight: 'title',
  })
);

const AvatarContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
});

const Title = styled.span(
  css({
    display: 'inline-flex',
    alignItems: 'center',
    height: [35, 35, 48],
  })
);
